import { Button, useTheme } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import Tooltip from "../../../../Components/Atoms/Tooltip";

const CustomButton = (props) => {

  const theme = useTheme();
  const { children } = props;
  const tooltip = props.tooltip;
  const { sx: sxProp, variant: variantProp, ...restProps } = props;
  const variant = variantProp || 'contained';

  const mergedSx = {
    borderRadius: 3,
    padding: "8px 12px",
    justifyContent: "flex-start",
    alignItems: "center",
    textTransform: "none",
    color: variant === 'contained' ? '#fff' : undefined,
    ...sxProp,
  };

  const content = (
    <Button
      sx={mergedSx}
      color={restProps.color || "primary"}
      variant={variant}
      startIcon={restProps.startIcon ?? <AddIcon />}
      {...restProps}
    >
      {children}
    </Button>
  );

  if (!tooltip) return content;
  return (
    <Tooltip title={tooltip}>
      {content}
    </Tooltip>
  );
};

export default CustomButton;
